import * as React from "react";
import { cn } from "@/lib/utils";
import { Close } from "@/assets/svg/Close";
import { useTranslation } from "react-i18next";

export const SelectedValueBadge = React.memo(function SelectedValueBadge({
  label,
  value,
  onRemove,
  isValid = true,
}: {
  label: string;
  value: string;
  isValid?: boolean;
  onRemove: (value: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "flex h-5 min-w-0 flex-row items-center gap-0.5 rounded-lg bg-accent py-0.5 pr-1 pl-3 text-xs font-light text-ellipsis text-foreground",
        { "bg-destructive-background text-destructive": !isValid },
      )}
      aria-invalid={!isValid}
      data-testid={`selected-value-badge-${value}`}
    >
      <div className="min-w-0 overflow-hidden text-ellipsis">{label}</div>
      <span
        className="p-1"
        aria-label={t("global.remove")}
        role="button"
        onMouseDown={(e) => {
          e.preventDefault();
          onRemove(value);
        }}
      >
        <Close
          aria-hidden={true}
          strokeWidth={2}
          className={cn("text-icon size-2", {
            "text-destructive": !isValid,
          })}
        />
      </span>
    </span>
  );
});
